function StorytellingTypographySection({
  title,
  role,
  display,
  updateDisplay,
  fontOptions,
  sizeOptions,
  defaultColor,
  hideColor = false,
  t,
}) {
  const familyField = `${role}FontFamily`;
  const sizeField = `${role}FontSize`;
  const colorField = `${role}Color`;
  const selectId = `storytelling-${role}-font`;

  return (
    <div className="storytelling-stepper__control-section mb-4">
      <h5 className="storytelling-stepper__control-title">{title}</h5>

      <div className="mb-3">
        <label className="form-label text-primary" htmlFor={selectId}>
          {t("storytellingTypographyFontLabel")}
        </label>
        <select
          id={selectId}
          className="form-select storytelling-font-select"
          value={display[familyField]}
          onChange={(e) => updateDisplay(familyField, e.target.value)}
          style={{
            fontFamily:
              fontOptions.find((opt) => opt.value === display[familyField])?.fontFamily ||
              fontOptions[0]?.fontFamily,
          }}
        >
          {fontOptions.map((opt) => (
            <option
              key={opt.value}
              value={opt.value}
              style={{ fontFamily: opt.fontFamily }}
            >
              {opt.label}
            </option>
          ))}
        </select>
      </div>

      <div className="mb-3">
        <label className="form-label text-primary">
          {t("storytellingTypographySizeLabel")}
        </label>
        <div className="storytelling-stepper__option-group">
          {sizeOptions.map((opt) => (
            <button
              key={opt.value}
              type="button"
              className={`storytelling-stepper__option-btn${
                display[sizeField] === opt.value
                  ? " storytelling-stepper__option-btn--active"
                  : ""
              }`}
              onClick={() => updateDisplay(sizeField, opt.value)}
            >
              {opt.label}
            </button>
          ))}
        </div>
      </div>

      <div>
        {!hideColor ? (
          <>
            <label className="form-label text-primary" htmlFor={`storytelling-${role}-color`}>
              {t("storytellingTypographyColorLabel")}
            </label>
            <div className="storytelling-stepper__color-row">
              <input
                id={`storytelling-${role}-color`}
                type="color"
                value={display[colorField] || defaultColor}
                onChange={(e) => updateDisplay(colorField, e.target.value)}
              />
              <button
                type="button"
                className="btn btn-sm btn-outline-secondary"
                onClick={() => updateDisplay(colorField, defaultColor)}
              >
                {t("storytellingResetColor")}
              </button>
            </div>
          </>
        ) : null}
      </div>
    </div>
  );
}

export default StorytellingTypographySection;
